import { defineStore } from "pinia";
import { planService } from "@/_services";

export const planStore = defineStore("plan", {
  state: () => ({
    plans: null,
    plansCalendar: null,
    plansExport: null,
    planById: null,
    planMap: null,
    planMapError: null,
    planUpdated: null,
    kanbanRoutesUpdated: null,
    kanbanRoutesOptimized: null,
    planDeleted: null,
    planCreated: null,
    error: null,
    customFilterDate: null,

  }),
  actions: {
    setCustomFilterDate(value){
      this.customFilterDate= value;
    },
    getPlans(pagination, query, sort) {
      this.error = null;
      return planService
        .getPlans(pagination, query, sort)
        .then((result) => {
          this.plans = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    getPlansByDateRange(dateFrom, dateTo) {
      this.error = null;
      return planService
        .getPlansByDateRange(dateFrom, dateTo)
        .then((result) => {
          this.plansCalendar = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.plansExport = null;
      return planService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.plansExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    createPlan(data) {
      this.error = null;
      this.planCreated = null;
      return planService
        .createPlan(data)
        .then((result) => {
          this.planCreated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    clearCreateState() {
      this.planCreated = null;
    },
    getPlanByIdForKanban(planId) {
      this.error = null;
      return planService
        .getPlanById(planId)
        .then((result) => {
          this.planById = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getPlanMapForKanban(planId) {
      this.error = null;
      this.planMap = null;
      this.planMapError = null;
      return planService
        .getPlanMap(planId)
        .then((result) => {
          this.planMap = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          this.planMapError = reason;
          throw reason;
        });
    },
    updatePlanStatusForKanban(planId, status) {
      this.error = null;
      this.planUpdated = null;
      const planIds = Array.isArray(planId) ? planId.join(',') : planId;
      planService
        .updatePlanStatus(planIds, status)
        .then((result) => {
          this.planUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    sendPlanStatusMulti(planIds) {
      this.error = null;
      this.planUpdated = null;
      planService
        .updatePlanStatus(planIds, "EN_CURSO")
        .then((result) => {
          this.planUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    deletePlanStatusMulti(planIds) {
      this.error = null;
      this.planDeleted = null;
      planService
        .updatePlanStatus(planIds, 'FINALIZADO')
        .then((result) => {
          this.planDeleted = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    assignVehicleToRouteForKanban(planId, vehicleId) {
      this.error = null;
      return planService
        .assignVehicleToRoute(planId, vehicleId)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    assignUnassignedStopToRouteForKanban(planId, routeId, stopIds, newOrder) {
      this.error = null;
      return planService
        .assignUnassignedStopToRoute(planId, routeId, stopIds, newOrder)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    moveRouteStopToRouteForKanban(planId, sourceRouteId, routeStopIds, targetRouteId, newOrder) {
      this.error = null;
      return planService
        .moveRouteStopToRoute(planId, sourceRouteId, routeStopIds, targetRouteId, newOrder)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    reorderRouteStopForKanban(planId, routeId, routeStopIds, newOrder) {
      this.error = null;
      return planService
        .reorderRouteStop(planId, routeId, routeStopIds, newOrder)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    unassignRouteStopForKanban(planId, routeId, routeStopIds) {
      this.error = null;
      return planService
        .unassignRouteStop(planId, routeId, routeStopIds)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    updateRouteStopInstructionsForKanban(planId, routeId, routeStopId, instructions) {
      this.error = null;
      return planService
        .updateRouteStopInstructions(planId, routeId, routeStopId, instructions)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    deleteRouteForKanban(planId, routeId) {
      this.error = null;
      return planService
        .deleteRoute(planId, routeId)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    createUnloadStopForKanban(planId, routeId, warehouseId, taskIds, newOrder, stopId = null) {
      this.error = null;
      return planService
        .createUnloadStop(planId, routeId, warehouseId, taskIds, newOrder, stopId)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    createLoadStopForKanban(planId, routeId, warehouseId, taskIds, newOrder, stopId = null) {
      this.error = null;
      return planService
        .createLoadStop(planId, routeId, warehouseId, taskIds, newOrder, stopId)
        .then((result) => {
          this.kanbanRoutesUpdated = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    optimizePlanRoutesForKanban(planId) {
      this.error = null;
      this.kanbanRoutesOptimized = null;
      return planService
        .optimizePlanRoutes(planId)
        .then((result) => {
          this.kanbanRoutesOptimized = result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
